import { compose, get } from 'lodash/fp';

function makeFeatureFlagSelector(key) {
  return compose(Boolean, get(['featureFlags', key, 'enabled']));
}

export default makeFeatureFlagSelector;
